// extracted by mini-css-extract-plugin
export default {"icon":"EntityCell_icon__17gzv","main":"EntityCell_main__1l4wC","iconDiv":"EntityCell_iconDiv__6AU6E"};